import { useId } from "react";
import './CheckboxComponent.scss';

export interface CheckboxProps {
  label: string;
  isSelected: boolean;
  isReadOnly: boolean;
  id:string,
  onCheckboxChange: (event: any) => void;
}

const generateUniqueId = (): string => {
  return crypto.randomUUID();
};

const uniqueId = generateUniqueId();

const Checkbox = ({ label, isSelected, isReadOnly, id, onCheckboxChange }: CheckboxProps) => (
    <label className="form-check-label" htmlFor={id}>
      <input
        type="checkbox"
        id={id}
        name={label}
        checked={isSelected}
        disabled={isReadOnly}
        onChange={onCheckboxChange}
        className="form-check-input"
      />
      {label}
    </label>
);

export default Checkbox;